<!--标准版--我的信贷-->

<template>
  <div>
    <div class="loan-table">
      <!--设计稿高度为500px，这里底层页面的高度没那么高，会溢出-->
      <el-table class="table-body pointer" :data="loanListData" style="width: 890px" @row-click="toLoanDetail">
        <el-table-column type='index' label="期次" width="65">

          <template slot-scope="scope">
            <span class="item_index">
              {{scope.$index + 1}}</span>
          </template>

        </el-table-column>
        <el-table-column prop="frontApplyProductName" label="产品名称" width="120"></el-table-column>
        <el-table-column prop="frontApplyDate" label="借款日期" width="100"></el-table-column>
        <el-table-column class-name="front-apply-money" prop="frontApplyMoney" :formatter="formatMoney" label="借款金额"
                         width="150"></el-table-column>
        <el-table-column prop="bankAccountInfo" label="借款银行" width="180"></el-table-column>
        <el-table-column prop="frontApplyStateTxt" label="状态" width="80"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.isEditable === '0'">
              <el-button size="mini" @click.stop="toLoanEdit(scope.row)">
                {{loanAction.editText}}
              </el-button>
              <el-button size="mini" @click.stop="toLoanDelete(scope.row.frontApplyId, scope.row.itemApplyId)">
                {{loanAction.deleteText}}
              </el-button>
            </div>
             <div v-else-if="scope.row.isEditable === '2'">
              <el-button size="mini" @click.stop="toLoanEdit(scope.row)">
                {{loanAction.editText}}
              </el-button>
              <button class="disabled_btn">{{loanAction.deleteText}}</button>
            </div>
            <div v-else>
              <button class="disabled_btn">{{loanAction.editText}}</button>
              <button class="disabled_btn">{{loanAction.deleteText}}</button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pament-list-pagination" :small="isSmall"
                     layout="prev, pager, next" :page-count="pageCount"
                     :page-size="10" style="text-align: center;" :currentPage.sync="pageCurrent"
                     @current-change="getPage" v-show="pageCount > 1"></el-pagination>
    </div>
    <confirm-modal :show="isDeleteLoanItemFrontApply" content="是否确定删除该条借款？" @confirm-click="deleteLoanItem"
                   @cancel-click="isDeleteLoanItemFrontApply = false"></confirm-modal>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import _ from 'lodash'
  import confirmModal from '../common/Confirm.vue'
  export default {
    data () {
      return {
        isSmall: true,
        isDeleteLoanItemFrontApply: false,
        frontApplyId: '',
        itemApplyId: '',
        loanAction: {
          editText: '编辑',
          deleteText: '删除'
        }
      }
    },
    components: {
      confirmModal
    },
    computed: {
      ...mapGetters({
        activeName: types.ACTIVE_NAME,
        userInfo: types.GET_USER,
        pageCurrent: types.PAGE_CURRENT,
        frontApplyState: types.FRONT_APPLY_STATE,
        loanListData: types.LOAN_LIST_DATA,
        pageCount: types.PAGE_COUNT
      })
    },
    methods: {
      ...mapMutations({
        setFrontApplyState: types.SET_FRONT_APPLY_STATE,
        setActiveName: types.SET_ACTIVE_NAME,
        setFrontItemApplyState: types.SET_FRONT_ITEM_STATE_FRONT
      }),
      ...mapActions({
        getLoanListData: types.GET_MY_LOAN_LISTS_DATA,
        getPageCurrent: types.GET_PAGE_CURRENT,
        deleteLoanItemFrontApply: types.DELETE_LOAN_ITEM_FRONT_APPLY
      }),
      formatMoney (obj) {
        const num = Number(obj.frontApplyMoney)
        let fmNum = !_.isNaN(num) ? (`${num.toFixed(0)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : ''
        fmNum = `￥${fmNum}`
        return fmNum
      },
      toLoanDetail (row, event, column) {
        const target = event.target
        if (target.className !== 'disabled_btn') {
          this.setActiveName('2')
          this.setFrontItemApplyState(row.frontApplyState)
          this.$router.push({path: `/loanDetail/${row.frontApplyId}`})
        }
      },
      toLoanEdit (row) {
        const query = {
          applyLoanId: row.frontApplyId,
          isEdit: true
        }
        switch (row.frontApplyState) {
          case 'f1':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step2_xd`,
              query
            })
            break
          case 'f2':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step3_xd`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          case 'f3':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step4_xd`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          case 'f4':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step4_xd`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          default:
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step2_xd`,
              query
            })
            break
        }
      },
      toLoanDelete (frontApplyId, itemApplyId) {
        this.frontApplyId = frontApplyId
        this.itemApplyId = itemApplyId
        this.isDeleteLoanItemFrontApply = true
      },
      deleteLoanItem () {
        this.deleteLoanItemFrontApply({
          token: this.userInfo.token,
          frontApplyId: this.frontApplyId,
          itemApplyId: this.itemApplyId
        }).then(() => {
          this.isDeleteLoanItemFrontApply = false
          this.getLoanListData({
            router: this.$router,
            frontApplyState: this.$route.query.frontApplyState,
            pageCurrent: this.pageCurrent,
            token: this.userInfo.token
          })
        })
      },
      getPage (currentPage) {
//        if (currentPage === 1) {
//          debugger
//        } else {
        this.getPageCurrent({pageCurrent: currentPage})
        this.$router.push({
          path: '/personalCenter/myloan/loanLists',
          query: {
            frontApplyState: this.frontApplyState,
            pageCurrent: this.pageCurrent
          }
        })
//        }
      }
    },
    created () {
      this.getLoanListData({
        token: this.userInfo.token,
        frontApplyState: 0,
        pageCurrent: this.pageCurrent
      })
      this.setActiveName('0')
    },
    watch: {
      $route () {
        if (_.isEmpty(this.$route.query)) {
          this.setActiveName('2')
          this.setFrontApplyState(2)
        } else if (this.$route.query.frontApplyState !== this.frontApplyState) {
          this.setFrontApplyState(this.$route.query.frontApplyState)
          this.getPageCurrent({pageCurrent: 1})
        }
        this.getLoanListData({
          token: this.userInfo.token,
          frontApplyState: this.frontApplyState,
          pageCurrent: this.pageCurrent
        })
      }
    }
  }
</script>
<style lang="scss">
  .front-apply-money {
    color: #35c4f9;
  }

  .loan-table {
    .el-tabs__active-bar {
      width: 0;
    }

    .el-button--mini {
      width: 44px;
      height: 22px;
      color: #fff;
      font-family: 'FZLanTingHei-DB-GBK';
      background: #35c4f9;
      border: none;
      position: relative;
    }
    .el-button--mini span{  position: absolute;
      left: 9px;
      top: 5px;}
    .el-button:focus,
    .el-button:hover {
      color: #fff;
    }

    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      color: #fff;
      background-color: #99a3a7;
    }

    .el-pager li.number {
      line-height: 19px;
      color: #a1a9ac;
      &.active {
        color: #21c2f9;
        border-color: transparent;
        background-color: transparent;
      }
    }

    .el-pagination {
      padding: 12px 0;
      button.disabled {
        color: #99a2a7;
      }
    }

    .el-table__body-wrapper {

      tr {
        position: relative;
        &:not(:first-child):after {
          content: '';
          position: absolute;
          left: 13px;
          height: 1px;
          width: 846px;
          background-color: #F6F6F6;
        }
      }
    }

    .table-body {
      box-sizing: border-box;
      border: none;

      &:before {
        display: none;
      }

      &:after {
        display: none;
      }

      td {
        /*border-bottom: 1px solid #F6F6F6;*/
        border-bottom: none;
      }

      th.is-leaf {
        border-bottom: none;
        overflow: hidden;
        height: 27px;
        background: none;
      }

      .cell {
        text-align: center;
        line-height: 59px;
        font-size: 14px;
        font-weight: bold;
      }

      th .cell {
        font-size: 12px;
        color: #cdd8dc;
        line-height: 27px;
        background: none;
      }

      .item_index {
        position: relative;
        display: inline-block;
        border-radius: 2px;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: $white;
        font-size: 12px;
        font-weight: normal;
        background: #cdd8dc;
      }
    }
  }

  .disabled_btn{
    display:inline-block;
    width:44px;
    height:22px;
    margin:0 5px;
    background: #99A3A7;
    font-size: 12px;
    border:none;
    border-radius: 3px;
    color:#fff;
    cursor: not-allowed;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// LoanLists.vue?343b6b0a